"use strict";

define('uikit/helper/browser',['jquery'], function ($) {
  var Browser = {
    isIE: function isIE() {
      var userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.indexOf('msie') != -1) {
        return parseInt(userAgent.split('msie')[1]);
      } else if (userAgent.indexOf('trident') != -1) {
        return parseInt(userAgent.split('rv:')[1]);
      }
      return false;
    }
  };
  return Browser;
});

